import React from 'react';

import createReactClass from 'create-react-class';
export default createReactClass({
  componentDidMount: function() {
    var self = this;
    $(this.refs.slider)
      .noUiSlider({
        start: parseInt(this.props.defaultValue),
        range: {
          min: parseInt(this.props.min),
          max: parseInt(this.props.max),
        },
      })
      .on('slide', function(event) {
        event.target = { value: parseInt($(this).val()) };
        self.props.onChange(event);
      });
  },

  componentWillUnmount: function() {},

  render: function() {
    var classes = ['control-group'];
    if (this.props.className) {
      classes.push(this.props.className);
    }
    return (
      <div className={classes.join(' ')} style={this.props.style}>
        <label>{this.props.label}</label>
        <div className="controls">
          <div ref="slider" className="slider"></div>
        </div>
      </div>
    );
  },
});
